import React, { useEffect, useState, useContext, Fragment } from 'react'
import { PageHandlerProps, PageDesiger } from '../PageDesiger'
import api, { AppPage, AppPageLayout } from 'api'
import './AppPageDesiger.less'

interface AppPageDesigerContext {
	appPage: AppPage
}

export const AppPageDesigerContext = React.createContext<AppPageDesigerContext>({} as AppPageDesigerContext)

export const AppPageDesiger = (props: PageHandlerProps) => {
	const [appPage, setAppPage] = useState({} as AppPage)
	useEffect(() => {
		loadData()
	}, [])
	const loadData = async () => {
		let { metadataId, application } = props
		let data = await api.modeling.apppage.getOne({ id: metadataId, application })
		setAppPage(data)
	}
	return (
		<Fragment>
			{JSON.stringify(appPage) === '{}' ? (
				''
			) : (
				<AppPageDesigerContext.Provider value={{ appPage }}>
					<div className="app-page-desiger page-layout-tiled page-layout-onecolumn">
						<div
							className={`row ${appPage.layoutType === 2 ? 'flex-row' : ''}`}
							style={{ height: '100%', width: '100%' }}
						>
							{appPage.layoutType === 2 ? <AppPageSiderDesiger index={0} /> : ''}
							<div
								className="cell"
								style={{
									height: '100%',
									width:
										appPage.layoutType === 1
											? '100%'
											: `calc(100% - ${(appPage.appPageLayoutList.length > 0 &&
													appPage.appPageLayoutList[0].width) ||
													300}px`,
								}}
							>
								<div className="cell-box">
									{appPage.appPageLayoutList.map((page: AppPageLayout, index: number) => {
										if (index === 0 && appPage.layoutType === 2) {
											return ''
										}
										return <AppPageCellDesiger key={index} index={index} />
									})}
								</div>
							</div>
						</div>
					</div>
				</AppPageDesigerContext.Provider>
			)}
		</Fragment>
	)
}

const AppPageSiderDesiger = (props: { index: number }) => {
	const context = useContext(AppPageDesigerContext)
	let appPageLayout = context.appPage.appPageLayoutList[props.index]
	return (
		<div className="cell" style={{ height: '100%', width: appPageLayout.width || 300 }}>
			<div className="cell-box">
				<div className="row" style={{ height: '100%', width: '100%' }}>
					<div className="cell" style={{ height: '100%', width: '100%' }}>
						<div className="cell-box">
							<PageDesiger {...appPageLayout} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const AppPageCellDesiger = (props: { index: number }) => {
	const context = useContext(AppPageDesigerContext)
	let appPageLayout = context.appPage.appPageLayoutList[props.index]
	return (
		<div className="row" style={{ height: appPageLayout.height || 400, width: '100%' }}>
			<div className="cell" style={{ height: '100%', width: '100%' }}>
				<div className="cell-box">
					<PageDesiger {...appPageLayout} />
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppPageDesiger/AppPageDesiger.tsx